/**
 * The Daily Summary card's headline: which lines it says for the day's two numbers. Mirrored 1:1 by
 * iOS `BriefHeadline.lines` and Android `briefHeadlineLines`, over the same cases.
 *
 * A number that is zero is left out rather than said ("0 are moving now" reads as the team doing
 * nothing). With both zero the card says the meeting's own headline, which is real news, and only
 * without one the quiet line.
 */
export type BriefHeadlineLine = { key: string; count?: number } | { text: string };

export function briefHeadlineLines(closed: number, moving: number, briefHeadline?: string): BriefHeadlineLine[] {
  const closedLine = { key: closed === 1 ? 'home.overview.summary.closedOne' : 'home.overview.summary.closedOther', count: closed };
  if (closed > 0 && moving > 0) {
    return [closedLine, { key: moving === 1 ? 'home.overview.summary.movingOne' : 'home.overview.summary.movingOther', count: moving }];
  }
  if (closed > 0) return [closedLine];
  if (moving > 0) {
    return [{ key: moving === 1 ? 'home.overview.summary.workingOne' : 'home.overview.summary.workingOther', count: moving }];
  }
  const text = briefHeadline?.trim();
  return text ? [{ text }] : [{ key: 'home.overview.summary.quiet' }];
}
